function objectToOption(object, indexes) {
  // first filter the index has value then if no value the id will be use
  const firstName = object?.employee?.firstName || "";
  const lastName = object?.employee?.lastName || "";
  return {
    label: `${firstName} ${lastName}`.trim() || object?.id,
    value: object.id,
    object: object,
  };
}

export default objectToOption;
